import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getEngVideoCompilationEnabled,
  getVideoCompilationEnabled
} from '../../../redux/modules/auth';
import VpButton from '../VpButton';
import VpConditionalUpgradeWrapper from '../VpConditionalUpgradeWrapper/VpConditionalUpgradeWrapper';
import { useFetchAllCampaigns } from '../../../hooks';

const CreateCompilationButton = ({ enabled, videoCompilationEnabled, ...rest }) => {
  if (!enabled) return <></>;

  const { data } = useFetchAllCampaigns();
  const hasCampaigns = !!data?.length;

  const label =
    'You do not have any campaigns created. Before creating a commpilation please create a campaign.';

  return (
    <VpConditionalUpgradeWrapper
      viewerRestricted
      condition={!videoCompilationEnabled || !hasCampaigns}
      {...(videoCompilationEnabled && !hasCampaigns ? { label } : {})}
    >
      {({ isDisabled }) => (
        <VpButton variant="text" disabled={isDisabled} {...rest}>
          Create Compilation
        </VpButton>
      )}
    </VpConditionalUpgradeWrapper>
  );
};

CreateCompilationButton.propTypes = {
  enabled: PropTypes.bool,
  videoCompilationEnabled: PropTypes.bool
};

const mapStateToProps = (state) => ({
  enabled: getEngVideoCompilationEnabled(state),
  videoCompilationEnabled: getVideoCompilationEnabled(state)
});

export default connect(mapStateToProps)(CreateCompilationButton);



// WEBPACK FOOTER //
// ./src/vp-ui/components/ToPublishingPageButton/CreateCompilationButton.jsx